import formats from '../../api/formats'
import AssistClasses from '../assist/AssistClasses.js'
import DocAbstract from './DocAbstract.js'

class Strategy extends DocAbstract.Strategy {
  getTypeCode () {
    return 'MARRIAGE_CERT_RF'
  }
  getTypeName () {
    return 'Свидетельство о заключении брака'
  }
  createModel () {
    var model = new Model()
    return model
  }
  createDefaultModel (individual) {
    let ops = {}
    if (individual.sex) {
      if (individual.sex === 'M') {
        Object.assign(ops, {
          surnameM: individual.lastName,
          firstnameM: individual.firstName,
          patronymicM: individual.middleName,
          birthdayM: individual.birthday
        })
      }
      if (individual.sex === 'F') {
        Object.assign(ops, {
          surnameF: individual.lastName,
          firstnameF: individual.firstName,
          patronymicF: individual.middleName,
          birthdayF: individual.birthday
        })
      }
    }
    return Object.assign(this.createModel(), ops)
  }
  updateSteps (scheme) {
    const formatSerNum = (v) => {
      let ms = /^([IVX]{1,})[\s-]*([А-ЯЁ]{2,2})[\s-№#]*(\d{6})$/.exec(v.toUpperCase())
      v = ms ? `${ms[1]} ${ms[2]} ${ms[3]}` : v
      return v
    }
    const ruleSerNum = (v) => !v || /^[IVX]{1,}\s*[А-ЯЁ]{2,2}\s*\d{6}$/.test(formatSerNum(v)) || 'Неверный формат - [I БЮ 123456]'
    const ruleNameRu = (v) => !v || formats.isNameRu(v, 60) || 'Допустимы русские буквы'

    let steps = []

    new AssistClasses.Step(
      '',
      (step) => {},
      {
        scheme: [
          {
            fieldType: 'v-text-field',
            label: 'Фамилия',
            name: 'surnameM',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Имя',
            name: 'firstnameM',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Отчество',
            name: 'patronymicM',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm8: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Гражданство',
            name: 'citizenshipM',
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Национальность',
            name: 'nationalityM',
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата рождения',
            name: 'birthdayM',
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Место рождения',
            name: 'birthplaceM',
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Фамилия',
            name: 'surnameF',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Имя',
            name: 'firstnameF',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Отчество',
            name: 'patronymicF',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm8: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Гражданство',
            name: 'citizenshipF',
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Национальность',
            name: 'nationalityF',
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата рождения',
            name: 'birthdayF',
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Место рождения',
            name: 'birthplaceF',
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата заключения брака',
            name: 'married',
            grow: true,
            size: {sm8: true, xs12: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата регистрации',
            name: 'registered',
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Номер записи об акте заключения брака',
            name: 'registerNumber',
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Фамилия мужа после заключения брака',
            name: 'surnameNewM',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm8: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Фамилия жены после заключения брака',
            name: 'surnameNewF',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm8: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Место государственной регистрации',
            name: 'issuer',
            grow: true,
            size: {sm12: true, xs12: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата выдачи',
            name: 'issued',
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Серия номер удостоверения',
            name: 'sernum',
            format: formatSerNum,
            rules: Array.of(ruleSerNum),
            grow: true,
            size: {sm6: true, xs12: true}
          }
        ]
      },
      {
      }).addToArray(steps)

    this.steps = steps
    return this
  }
  viewNumber (model) {
    return `${model['sernum'] ? model['sernum'] : '-'}`
  }
  viewTitleComp (model) {
    return formats.createComp(`
      <span>${this.getTypeName()}</span>
    `)
  }
  viewContentComp (model) {
    return formats.createComp(`
      <div>
      <div>Номер удостоверения:<b> ${model['sernum'] ? model['sernum'] : '-'}</b></div>
      <div>Дата регистрации:<b> ${model['registered'] ? formats.formatDate(model['registered']) : '-'}</b></div>
      </div>`)
  }
}

class Model {
  constructor () {
    this.modelType = '103.01'
  }
}

function createStrategy (cxt) {
  return new Strategy(cxt)
}

export default {
  createStrategy,
  Model
}



// WEBPACK FOOTER //
// ./src/components/people/DocMarriageCertRF.js